import React from 'react';

const Title2 = () => {
    let css2={
        marginTop: '70px'
    }
    return (
        <div>
            <h3 style={css2}>여름을 위한 컬렉션</h3>
            <p>가볍게, 시원하게 썸머 컬렉션으로 여름을 준비해보세요.</p>
        </div>
    );
};

export default Title2;